const profileValidationDE = {
    "email": {
        "required": "Die E-Mail-Adresse ist erforderlich"
    },
    "profile_image": {
        "dimensions": "Das Profilbild muss genau 300 x 300 px, JPG/JPEG sein. Maximale Dateigröße 300 KB",
        "choose": "Bitte wählen Sie ein Bild",
        "file": "Die ausgewählte Datei ist größer als 300 KB. Bitte laden Sie ein Cover in 300x300 px, JPG/JPEG, max. Dateigröße 300 KB hoch."
    },
    "street_and_number": {
        "required": "Die Straße und Hausnummer sind erforderlich"
    },
    "postal_code": {
        "required": "Die Postleitzahl ist erforderlich"
    },
    "city": {
        "required": "Die Stadt ist erforderlich"
    },
    "country": {
        "required": "Das Land ist erforderlich"
    },
    "vat_number": {
        "invalid": "Der Wert ist keine gültige USt-IdNr."
    },
    "iban": {
        "required": "IBAN ist erforderlich",
        "invalid": "Der Wert ist keine gültige IBAN-Nummer"
    },
    "cardholder_name": {
        "required": "Der Name des Karteninhabers ist erforderlich"
    },
    "card_number": {
        "required": "Kartennummer ist erforderlich",
        "invalid": "Kartennummer ist nicht gültig"
    },
    "card_year": {
        "required": "Ablaufjahr ist erforderlich",
        "invalid": "Ablaufjahr ist nicht gültig"
    },
    "card_month": {
        "required": "Ablaufmonat ist erforderlich"
    },
    "cvc_code": {
        "required": "Sicherheitscode (CVC) ist erforderlich",
        "invalid": "Sicherheitscode (CVC) ist nicht gültig"
    },
    "paypal_email": {
        "required": "Paypal-E-Mail ist erforderlich",
        "invalid": "Paypal-E-Mail ist nicht gültig"
    },
    "account_holder_name": {
        "required": "Der Name des Kontoinhabers ist erforderlich"
    },
    "bank_name": {
        "required": "Der Name der Bank ist erforderlich"
    },
    "bank_address": {
        "required": "Die Bankadresse ist erforderlich"
    },
    "preferred_payment_method": {
        "required": "Bevorzugte Zahlungsmethode ist erforderlich"
    }
};

export default profileValidationDE;